<script>
import ImageThumbnailer from '@/utils/ImageThumbnailer.js'
export default {
  data () {
    return {
      isProcessingImage: false
    }
  },
  methods: {
    processImageFile (e, params) {
      if (params.blobObjKeys.length !== params.compressOptions.length) return alert(`程式錯誤，processImageFile 必須每一張圖片與對應的key`)
      let isImg = e.file.type.indexOf('image') >= 0
      if (!isImg) { return alert('請上傳圖片檔案') }

      this[params.isProcessingImageKey || 'isProcessingImage'] = true
      this.$refs[params.elUploadRefKey].clearFiles()

      const onThumb = (blobs, params) => {
        for (var i = 0; i < blobs.length; ++i) {
          let blob = blobs[i]
          let objKey = params.blobObjKeys[i]
          this.$set(params.formObject, objKey, blob)
        }
        this.$set(params.formObject, params.blobObjectURLKey, URL.createObjectURL(blobs[0]))

        this[params.isProcessingImageKey || 'isProcessingImage'] = false
      }

      if (params.notCompress) {
        return onThumb([e.file], params)
      }

      let compressPromiseList = []
      for (let opts of params.compressOptions) {
        let promise = new Promise((resolve, reject) => {
          ImageThumbnailer.shared.requestCompress(
            e.file,
            blob => {
              resolve(blob)
            },
            opts
          )
        })
        compressPromiseList.push(promise)
      }
      Promise.all(compressPromiseList).then(results => {
        onThumb(results, params)
      })
    },
    onImageLoaded (evt, params) {
      if (params.blobObjKeys.length !== params.uploadPathPrefixList.length) return alert(`程式錯誤，processImageFile 必須每一張圖片與對應的upload path`)
      if (evt.target.src.startsWith('http')) return

      const removeBlobs = () => {
        for (let objKey of params.blobObjKeys) {
          this.$set(params.formObject, objKey, undefined)
        }
        this.$set(params.formObject, params.blobObjectURLKey, null)
      }
      const uploadBlobs = () => {
        this[params.isProcessingImageKey || 'isProcessingImage'] = true

        let uploadPromiseList = []
        for (var i = 0; i < params.blobObjKeys.length; ++i) {
          let objKey = params.blobObjKeys[i]
          let pathPrefix = params.uploadPathPrefixList[i]

          let promise = this.$services.firebase.upload(
            params.formObject[objKey],
            pathPrefix
          )
          uploadPromiseList.push(promise)
        }

        Promise.all(uploadPromiseList).then(urls => {
          for (var i = 0; i < params.imageURLFormKeys.length; ++i) {
            let imageURLKey = params.imageURLFormKeys[i]
            let url = urls[i]
            let blobObjKey = params.blobObjKeys[i]
            this.$set(params.formObject, imageURLKey, url)
            this.$set(params.formObject, blobObjKey, undefined)
          }
          if (params.onImageUploaded) params.onImageUploaded()
          this[params.isProcessingImageKey || 'isProcessingImage'] = false
          this.$set(params.formObject, params.blobObjectURLKey, null)
        })
      }

      let img = this.$refs[params.imgRefKey]
      let size = {
        w: img.naturalWidth,
        h: img.naturalHeight
      }
      if (size.w !== params.requiredSize.w || size.h !== params.requiredSize.h) {
        console.warn(`got error size: ${size.w}x${size.h}, but ${params.requiredSize.w}x${params.requiredSize.h} expected`)
        alert(`錯誤: 檔案尺寸錯誤! 請上傳 ${params.requiredSize.w}x${params.requiredSize.h}的圖片`)
        removeBlobs()
      } else {
        uploadBlobs()
      }
      URL.revokeObjectURL(evt.target.src)
    }
  }
}
</script>
